import * as React from "react";

function TrustPilot(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={212.99}
      height={58.01}
      {...props}
    >
      <defs>
        <radialGradient
          id="prefix__d"
          cx={0.715}
          cy={1.111}
          r={4.834}
          gradientTransform="matrix(.233 0 0 -1 .549 25.271)"
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#a8a8a8" />
          <stop offset={0.093} stopColor="#898989" />
          <stop offset={0.235} stopColor="#5f5f5f" />
          <stop offset={0.38} stopColor="#3d3d3d" />
          <stop offset={0.528} stopColor="#222" />
          <stop offset={0.678} stopColor="#0f0f0f" />
          <stop offset={0.831} stopColor="#040404" />
          <stop offset={0.995} />
        </radialGradient>
        <clipPath id="prefix__a">
          <path fill="none" d="M0 0h212.99v58.01H0z" />
        </clipPath>
        <style>
          {
            ".prefix__b{clip-path:url(#prefix__a)}.prefix__d,.prefix__g{fill:#fff}.prefix__g{fill-rule:evenodd}"
          }
        </style>
      </defs>
      <path fill="#24ae7b" d="M0 0h212.99v58.01H0z" />
      <g className="prefix__b">
        <path
          className="prefix__d"
          d="M70.034 33.769v3.811h-1.445a.3.3 0 01-.2-.2V27.066h1.577a4.64 4.64 0 00.066.92c1.051-1.38 2.365-1.38 3.745-.985a3.206 3.206 0 012.1 2.365 6.419 6.419 0 01.066 2.957 3.3 3.3 0 01-2.233 2.562 3.711 3.711 0 01-3.676-1.116zm-.329-2.825c.066.46.2.92.263 1.38a1.916 1.916 0 001.9 1.445 2 2 0 001.972-1.379 3.831 3.831 0 00-.132-2.825 1.923 1.923 0 00-1.774-1.248 1.78 1.78 0 00-1.839 1.248 4.246 4.246 0 00-.394 1.38zM90.991 31.075a3.611 3.611 0 01-1.38 3.219 4.093 4.093 0 01-4.139.525 3.5 3.5 0 01-2.234-3.153 4.3 4.3 0 01.723-3.219 4 4 0 014.467-1.314 3.588 3.588 0 012.563 3.416zm-1.578 0a10.952 10.952 0 00-.459-1.577 2.079 2.079 0 00-2.628-.986 2.95 2.95 0 00-.854.723 3.557 3.557 0 000 3.613 2.006 2.006 0 002.759.591 1.816 1.816 0 00.722-.854c.132-.459.329-1.05.46-1.51zM61.69 29.367h-1.577a.3.3 0 01-.2-.2 1.07 1.07 0 00-.854-.723 4.287 4.287 0 00-1.577.131.651.651 0 00-.46.788.673.673 0 00.328.394 7.744 7.744 0 001.314.46c.591.2 1.183.263 1.774.46a2.144 2.144 0 011.643 1.839 2.08 2.08 0 01-1.314 2.168 4.9 4.9 0 01-4.073.066 2.3 2.3 0 01-1.379-2.3h1.445c.066 0 .2.2.2.2a1.171 1.171 0 001.051.986 5.011 5.011 0 001.708-.131.777.777 0 00.591-.985.783.783 0 00-.525-.591 11.286 11.286 0 00-1.38-.46c-.59-.2-1.182-.263-1.708-.46a1.862 1.862 0 01-1.379-1.905 1.835 1.835 0 011.314-1.84 4.643 4.643 0 013.744 0 2.552 2.552 0 011.314 2.103zM36.856 25.951h-3.875v-1.445c0-.066.2-.2.328-.2h8.541v1.117h-1.183a1.938 1.938 0 01-1.576.526c-.329 0-.46.131-.46.46v8.278c0 .2-.066.328-.329.328h-1.116c-.329 0-.46-.131-.46-.46v-7.227zM52.563 27.068h1.379v7.424c0 .328-.066.526-.46.46a11.286 11.286 0 00-1.511 0v-.92c-.066.328-.46.591-.919.854a2.643 2.643 0 01-3.547-1.051 1.5 1.5 0 01-.264-.92 1.826 1.826 0 01-.065-.591v-4.73c0-.263.065-.394.394-.394h.92c.329 0 .459.066.459.46v4.73a1.352 1.352 0 001.314 1.445 1.627 1.627 0 001.9-1.248 3.639 3.639 0 00.131-1.182 17.389 17.389 0 01.264-3.679zM95.72 28.317h-.986c-.328 0-.459.131-.459.46v3.613c0 .788.2.985.985.985h.722v1.445a.294.294 0 01-.2.2c-.656 0-1.379 0-2.036-.066a1.054 1.054 0 01-.92-.985 5.125 5.125 0 01-.131-1.051 35.951 35.951 0 00-.2-3.81v-.328h-1.116v-1.708h.525c.789 0 .656.131.656-.723v-1.183c0-.2.066-.394.329-.394h.985a.3.3 0 01.329.263v1.642c0 .2.066.328.329.328h1.117a8.775 8.775 0 01.071 1.312zM62.478 28.645c0-.2-.066-.2 0-.394a1.391 1.391 0 01.985-.92c.2 0 .2-.131.2-.328v-1.971h1.446c.065 0 .2.2.2.263v1.643c0 .263.066.394.329.394h.92c.263 0 .263.131.263.263.065.985.065.985-.854.985h-.328c-.2 0-.329.066-.329.263v3.876c0 .854.2.985.986.985h.526v1.051q-.1.2-.2.2a10.6 10.6 0 01-2.036-.132 1.048 1.048 0 01-.92-.985c-.065-.657-.065-1.38-.131-2.1v-2.825c0-.328-.066-.525-.46-.525-.072.257-.334.323-.597.257zM41.848 27.068h1.708v1.319c-.263 0-.2 0-.2.066l.2-.263a2.409 2.409 0 012.365-1.117c.131 0 .263.2.263.2a9.782 9.782 0 010 1.38h-.329a2.143 2.143 0 00-2.5 2.1 33.225 33.225 0 00.131 3.613v.657h-1.708zM80.151 34.95V24.241h1.708V34.95zM76.8 27.265h1.445c.065 0 .2.2.2.394v7.227h-1.708zM76.8 24.243h1.708v1.38a.21.21 0 01-.2.2h-1.445zM17.213 31.206l-6.11-4.467c.985-.066 1.773 0 2.563 0a10.393 10.393 0 002.5-.2h2.563c.854-2.234 1.642-4.664 2.431-7.161.854 2.5 1.643 4.927 2.431 7.687h7.621c-3.022 2.037-15.373 10.906-16.228 11.234.717-2.428 1.44-4.727 2.229-7.093zM21.286 34.163l4.27-1.117a520.306 520.306 0 011.839 5.584z"
        />
      </g>
      <path
        d="M-4428.906-1049.607S-4621.4-994.29-4678.292-991.6h249.386v-58.01z"
        transform="translate(4641.896 1058.082)"
        style={{
          isolation: "isolate",
          mixBlendMode: "color-dodge",
        }}
        opacity={0.26}
        fill="url(#prefix__d)"
      />
      <text
        transform="translate(157.579 43.694)"
        style={{
          isolation: "isolate",
        }}
        fontSize={9}
        fontFamily="OpenSans,Open Sans"
        fill="#fff"
      >
        <tspan x={-34.064} y={0}>
          {"Excellent | 4.9/5"}
        </tspan>
      </text>
      <path
        className="prefix__g"
        d="M136.538 30.637l.789-5.387-3.614-3.876 5.059-.854 2.366-4.8 2.364 4.8 5.059.92-3.613 3.876.789 5.387-4.6-2.431-4.6 2.365z"
      />
      <path
        className="prefix__d"
        d="M153.882 30.637l.788-5.321-3.613-3.876 5.059-.854 2.365-4.8 2.366 4.8 5.059.92-3.614 3.81.789 5.387-4.6-2.431-4.6 2.365zM171.161 30.703l.788-5.387-3.613-3.876 5.058-.854 2.365-4.8 2.366 4.8 5.059.92-3.614 3.876.789 5.387-4.6-2.431-4.6 2.365zM196.388 29.915l-3.284-1.774-4.6 2.431.789-5.321-3.614-3.876 5.125-.854 2.365-4.8 2.365 4.8.854.131"
      />
      <path
        d="M196.323 20.651l4.2.723-3.613 3.876.789 5.322-1.314-.657"
        style={{
          isolation: "isolate",
        }}
        opacity={0.42}
        fill="#fff"
      />
      <path
        className="prefix__g"
        d="M123.924 15.724l-2.365 4.8-5.125.854 3.613 3.876-.788 5.387 4.6-2.431 4.6 2.431-.723-5.387 3.613-3.876-5.124-.854-2.3-4.8z"
      />
    </svg>
  );
}

export default TrustPilot;
